import { doc, updateDoc } from "firebase/firestore";

export function createTourHandlers({
    db,
    user,
    setUserProfile,
    setShowTour,
    setTourAction
}) {
    const handleTourFinish = async () => {
        if (user && !user.isAnonymous) {
            try {
                await updateDoc(doc(db, "users", user.uid), {
                    hasSeenTour: true
                });
                setUserProfile((prev) => ({ ...prev, hasSeenTour: true }));
            } catch (e) {
                console.error("Tour state save failed", e);
            }
        } else if (user && user.isAnonymous) {
            localStorage.setItem(`hasSeenTour_${user.uid}`, "true");
        }
        setShowTour(false);
        setTourAction(null);
    };

    return { handleTourFinish };
}
